import React, { useEffect, useState } from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import AccountLayoutWeb from "./AccountLayoutWeb";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { capitalize, isEmpty } from "lodash";
import moment from "moment/moment";
import BettingHistory from "./BettingHistory";
import AuthContext from "../../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import CustomPagination from "./CustomPagination";
import ProfitLoss from "./ProfitLoss";
const MyBetsWeb = () => {
  const [key, setKey] = useState("Exchange");
  const [tab, setTab] = useState("bets");
  const [data, setData] = useState([]);
  const today = moment().format("YYYY-MM-DD");
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const [pagination, setPagination] = useState({
    page: 0,
    totalPages: 0,
    hasPrevPage: false,
    hasNextPage: false,
  });
  const [loader, setLoader] = useState(false);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: previousDate,
    toPeriod: currentDate,
    page: 1,
    limit: 10,
  });
  const fetchData = async (endpoint, setter) => {
    try {
      setLoader(true);
      const { status, data: response } = await apiGet(endpoint, "");

      if (status === 200 && response.success) {
        setter(response.results);
      }
    } catch (error) {
      console.error("API fetch error:", error);
    } finally {
      setLoader(false);
    }
  };
  const calculateTotals = (markets, newTab, profileData = {}) => {
    if (!Array.isArray(markets) || markets.length === 0)
      return { totals: [], grandTotal: 0 };

    const commissionRate = parseFloat(profileData?.commission) || 0;
    let grandTotal = 0;

    const totals = markets.map((market) => {
      let backProfit = 0,
        backLoss = 0,
        layProfit = 0,
        layLoss = 0,
        yesProfit = 0,
        yesLoss = 0,
        noProfit = 0,
        noLoss = 0,
        resultTotalStake = 0; // 🧮 total amount of all bets

      const updatedBets = (market.bets_list || []).map((bet) => {
        const profit = parseFloat(bet.profitAmount) || 0;
        const loss = parseFloat(bet.loseAmount) || 0;
        const amount = parseFloat(bet.amount) || 0;
        resultTotalStake += amount; // ✅ add to total stake

        let updatedResult = 0;

        // 🎯 Exchange Back/Lay
        if (bet.betType === "back") {
          if (bet.teamSelectionWin === bet.selectionId) {
            backProfit += profit;
            updatedResult = profit;
          } else {
            backLoss += loss;
            updatedResult = -loss;
          }
        } else if (bet.betType === "lay") {
          if (bet.teamSelectionWin !== bet.selectionId) {
            layProfit += profit;
            updatedResult = profit;
          } else {
            layLoss += loss;
            updatedResult = -loss;
          }
        }

        // 🎯 Fancy Yes/No
        if (bet.type === "Yes") {
          if (bet.decisionRun >= bet.betRun) {
            yesProfit += profit;
            updatedResult = profit;
          } else {
            yesLoss += loss;
            updatedResult = -loss;
          }
        } else if (bet.type === "No") {
          if (bet.decisionRun < bet.betRun) {
            noProfit += profit;
            updatedResult = profit;
          } else {
            noLoss += loss;
            updatedResult = -loss;
          }
        }

        return { ...bet, updatedResult };
      });

      // ✅ Subtotals
      const backSubTotalresult = backProfit - backLoss;
      const laySubTotalresult = layProfit - layLoss;
      const marketSubTotal = backSubTotalresult + laySubTotalresult;

      const yesSubTotalresult = yesProfit - yesLoss;
      const noSubTotalresult = noProfit - noLoss;
      const fancyMarketSubTotal = yesSubTotalresult + noSubTotalresult;

      // ✅ Commission
      const commission =
        marketSubTotal > 0 ? (marketSubTotal * commissionRate) / 100 : 0;

      // ✅ Net totals
      const netAmount =
        newTab === "Fancy" ? fancyMarketSubTotal : marketSubTotal - commission;

      grandTotal += netAmount;

      return {
        ...market,
        bets_list: updatedBets,
        resultTotalStake, // ✅ total stake per market
        yesSubTotalresult,
        noSubTotalresult,
        backSubTotalresult,
        laySubTotalresult,
        fancyMarketSubTotal,
        marketSubTotal,
        commission,
        netAmount,
      };
    });

    return { totals, grandTotal };
  };

  const getData = async (page) => {
    setLoader(true);
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    let obj = {
      ...filter,
      page: page > 0 ? page : filter?.page,
      betType:
        key == "Exchange"
          ? "betfair"
          : key == "Fancy"
            ? "fancy"
            : key == "Sportsbook"
              ? "sportBook"
              : key == "bookmaker"
                ? "bookmaker"
                : "casino",
    };
    let api = tab == "histroy" ? apiPath.getHistory : apiPath.getProfitLoss;
    const { status, data: response_users } = await apiGet(api, obj);

    if (status === 200) {
      if (response_users.success == true) {
        setLoader(false);
        if (tab == "histroy") {
          setData(response_users?.results);
        } else {
          const { totals, grandTotal } = calculateTotals(
            response_users?.results?.data,
            key,
            profileData,
          );
          setData(totals);
        }
        setPagination({
          page: response_users?.results?.page,
          totalPages: response_users?.results?.totalPages,
          hasPrevPage: response_users?.results?.hasPrevPage,
          hasNextPage: response_users?.results?.hasNextPage,
        });
      } else {
        setPagination({
          page: 1,
          totalPages: 0,
          hasPrevPage: false,
          hasNextPage: false,
        });
        setLoader(false);
        setData([]);
      }
    }
  };
  useEffect(() => {
    setData([]);
    setPagination({
      page: 0,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: false,
    });
    if (tab == "bets") {
      const apiMap = {
        Exchange: {
          endpoint: apiPath.getCurrentBetsExchanges,
          setter: setData,
        },
        Fancy: { endpoint: apiPath.getFancyBets, setter: setData },
        Sportsbook: { endpoint: apiPath.getSportsBook, setter: setData },
        bookmaker: { endpoint: apiPath.getBookmakerBets, setter: setData },
      };

      const current = apiMap[key];
      if (current) fetchData(current.endpoint, current.setter);
    }
  }, [key, tab]);

  let betCheckObj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  const handleDateChange = (e) => {
    const { id, value } = e.target;

    if (id === "startDate") {
      if (filter.toPeriod && moment(value).isAfter(filter.toPeriod)) {
        return;
      }

      setFilter((prev) => ({ ...prev, fromPeriod: value }));
    }

    if (id === "endDate") {
      // Prevent selecting future date
      if (moment(value).isAfter(today)) {
        return;
      }
      // Prevent end date before start date
      if (filter.fromPeriod && moment(value).isBefore(filter.fromPeriod)) {
        return;
      }

      setFilter((prev) => ({ ...prev, toPeriod: value }));
    }
  };
  const handlePageChange = (newPage) => {
    getData(newPage);
  };
  return (
    <AccountLayoutWeb>
      <div className="col-center report">
        <h2>My Bets</h2>
        <ul className="tab col3">
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                setTab("bets");
              }}
              className={tab == "bets" ? "select" : ""}
            >
              Current Bets
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                setTab("histroy");
              }}
              className={tab == "histroy" ? "select" : ""}
            >
              Bets History
            </a>
          </li>
          <li>
            <a
              onClick={(e) => {
                e.preventDefault();
                setTab("profit");
              }}
              className={tab == "profit" ? "select" : ""}
            >
              Profit & Loss
            </a>
          </li>
        </ul>
        <ul
          className="report-tab-wrap"
          style={{
            display: "block",
          }}
        >
          <li
            onClick={() => setKey("Exchange")}
            className={`report-tab ${key == "Exchange" ? "select" : ""}`}
            data-reporttabtype="0"
            id="reportType_exchange"
          >
            Exchange
          </li>
          <li
            onClick={() => setKey("Fancy")}
            className={`report-tab ${key == "Fancy" ? "select" : ""}`}
            data-reporttabtype="7"
            id="reportType_fancyBet"
          >
            FancyBet
          </li>
          <li
            onClick={() => setKey("Sportsbook")}
            className={`report-tab ${key == "Sportsbook" ? "select" : ""}`}
            data-reporttabtype="2"
            id="reportType_sportsBook"
          >
            Sportsbook
          </li>
          <li
            onClick={() => setKey("bookmaker")}
            className={`report-tab ${key == "bookmaker" ? "select" : ""}`}
            data-reporttabtype="3"
            id="reportType_bookMaker"
          >
            BookMaker
          </li>
        </ul>
        <div className="function-wrap">
          <ul className="input-list">
            <li>
              <label>Bet Status</label>
            </li>
            <li>
              <select id="betStatus">
                <option value="">All</option>
                <option value="Unmatched">Unmatched</option>
                <option value="Matched">Matched</option>
              </select>
            </li>

            {tab == "bets" && (
              <>
                <li>
                  <label>Order By</label>
                </li>
                <li>
                  <input defaultChecked id="orderBetPlaced" type="checkbox" />
                  <label htmlFor="orderBetPlaced">Bet placed</label>
                  <input id="orderMarket" type="checkbox" />
                  <label htmlFor="orderMarket">Market</label>
                </li>
              </>
            )}
            {tab !== "bets" && (
              <li>
                <input
                  className="cal-input"
                  id="startDate"
                  type="date"
                  value={filter.fromPeriod}
                  max={today}
                  onChange={handleDateChange}
                  placeholder="YYYY-MM-DD"
                />
                <input
                  className="time-input"
                  id="startTime"
                  maxLength="5"
                  placeholder="09:00"
                  type="text"
                  disabled
                />
                to
                <input
                  className="cal-input"
                  id="endDate"
                  type="date"
                  value={filter.toPeriod}
                  max={today}
                  min={filter.fromPeriod}
                  onChange={handleDateChange}
                  placeholder="YYYY-MM-DD"
                />
                <input
                  className="time-input"
                  id="endTime"
                  maxLength="5"
                  placeholder="08:59"
                  type="text"
                  disabled
                />
              </li>
            )}
          </ul>
          {tab !== "bets" && (
            <ul className="input-list">
              <li>
                <div
                  onClick={() => {
                    setFilter((prev) => {
                      return {
                        ...prev,
                        fromPeriod: moment(new Date()).format("YYYY-MM-DD"),
                        toPeriod: moment(new Date()).format("YYYY-MM-DD"),
                      };
                    });
                  }}
                  className="btn"
                  id="today"
                >
                  Just For Today
                </div>
              </li>
              <li style={{}}>
                <div
                  onClick={() => {
                    setFilter((prev) => {
                      return {
                        ...prev,
                        fromPeriod: moment(new Date())
                          .subtract(1, "days")
                          .format("YYYY-MM-DD"),
                        toPeriod: moment(new Date()).format("YYYY-MM-DD"),
                      };
                    });
                  }}
                  className="btn"
                  id="yesterday"
                >
                  From Yesterday
                </div>
              </li>

              <li>
                <div style={{cursor:"pointer"}} className="btn-send" onClick={() => getData()} id="getPL">
                  Get History
                </div>
              </li>
            </ul>
          )}
        </div>
        <table className="table-s" id="Matched_Table">
          <caption>Matched</caption>
          <thead>
            {tab == "bets" ? (
              <tr>
                <th className="align-L" id="Matched_market">
                  Market
                </th>
                <th id="Matched_selection" width="10%">
                  Selection
                </th>
                <th id="Matched_type" width="3%">
                  Type
                </th>
                <th id="Matched_betId" width="9%">
                  Bet ID
                </th>
                <th id="Matched_betPlaced" width="8%">
                  Bet placed
                </th>
                <th id="Matched_oddsReq" width="8%">
                  Odds req.
                </th>
                <th id="Matched_matched" width="9%">
                  Matched
                </th>
                <th id="Matched_avgOdds" width="10%">
                  Avg. odds matched
                </th>
                <th id="Matched_dateMatched" width="10%">
                  Date matched
                </th>
              </tr>
            ) : tab == "profit" ? (
              <tr>
                <th className="align-L" id="Matched_market">
                  Market
                </th>
                <th id="Matched_selection" width="10%">
                  Start Time
                </th>
                <th id="Matched_type" width="10%">
                  Settled date
                </th>
                <th id="Matched_betId" width="10%">
                  Profit/Loss
                </th>
              </tr>
            ) : (
              <tr>
                <th className="align-L" id="Matched_market">
                  Bet ID
                </th>
                <th id="Matched_selection">PL ID</th>
                <th id="Matched_type" width="3%">
                  Market
                </th>
                <th id="Matched_betId" width="9%">
                  Selection
                </th>
                <th id="Matched_betPlaced" width="8%">
                  Type
                </th>
                <th id="Matched_oddsReq" width="8%">
                  Bet placed
                </th>
                <th id="Matched_matched" width="9%">
                  Odds req.
                </th>
                <th id="Matched_avgOdds" width="10%">
                  Stake
                </th>
                <th id="Matched_dateMatched" width="10%">
                  Avg. odds matched
                </th>
                <th id="Matched_dateMatched" width="10%">
                  Profit/Loss
                </th>
              </tr>
            )}
          </thead>
          {tab == "histroy" ? (
            <BettingHistory data={data} key={key} betCheckObj={betCheckObj} />
          ) : tab == "profit" ? (
            <ProfitLoss data={data} tab={key} betCheckObj={betCheckObj} />
          ) : (key == "Exchange" ? data?.matched : data)?.length > 0 ? (
            <tbody id="Matched_Content">
              {(key == "Exchange" ? data?.matched : data)?.map((item) => {
                return (
                  <tr
                    id="noDataTemplate"
                    style={{
                      display: "table-row",
                    }}
                  >
                    <td className="text-left">
                      <span style={{ textTransform: "uppercase" }}>
                        {betCheckObj[item?.eventType]}
                      </span>
                      <img
                        class="fromto"
                        src={cdnImg("assets/images/transparent.gif")}
                      />
                      <strong>{item?.matchName}</strong>
                      <img
                        class="fromto"
                        src={cdnImg("assets/images/transparent.gif")}
                      />
                      {capitalize(item?.betFaireType) || item?.fancyName}
                    </td>
                    <td className="text-end">
                      {item?.runnerName || item?.teamName}
                    </td>
                    <td className="text-end">
                      <span
                        className={
                          item?.betType == "lay" || item?.type == "No"
                            ? "lay-bg"
                            : item?.betType == "back" || item?.type == "Yes"
                              ? "back-bg"
                              : ""
                        }
                      >
                        {key === "Fancy"
                          ? capitalize(item?.type) || "N/A"
                          : capitalize(item?.betType)}
                      </span>
                    </td>
                    <td className="text-end">
                      <span
                        style={{
                          borderBottom: "1px solid",
                          cursor: "pointer",
                        }}
                        className="back-bg"
                      >
                        {" "}
                        {key === "Fancy" ? item?.selectionId : item?.matchBetId}
                      </span>
                    </td>
                    <td className="text-end">
                      {moment(item?.timeInserted).format("YYYY-MM-DD hh:mm:ss")}
                    </td>
                    <td className="text-end">
                      {" "}
                      {key === "Fancy"
                        ? item?.betRun + "/" + item?.bhav
                        : item?.bhav || "N/A"}
                    </td>
                    <td className="text-end"> {item?.amount || "N/A"} </td>{" "}
                    <td className="text-end">
                      {" "}
                      {key === "Fancy"
                        ? item?.betRun + "/" + item?.bhav
                        : item?.bhav || "N/A"}
                    </td>
                    <td className="text-end">
                      {moment(item?.timeInserted).format("YYYY-MM-DD hh:mm:ss")}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody id="Matched_Content">
              <tr
                id="noDataTemplate"
                style={{
                  display: "table-row",
                }}
              >
                <td className="no-data" colSpan="9">
                  <p>You have no bets in this time period.</p>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>{" "}
      {pagination?.page > 0 && (
        <CustomPagination
          pagination={pagination}
          onPageChange={handlePageChange}
        />
      )}
    </AccountLayoutWeb>
  );
};

export default MyBetsWeb;

export const headerDataBetHistory = [
  {
    class: "text-start",
    title: "Bet ID",
    widht: "",
  },
  {
    class: "text-start",
    title: "PL ID",
    widht: "",
  },
  {
    class: "text-start",
    title: "Market",
    widht: "30%",
  },
  {
    class: "text-end",
    title: "Selection",
    widht: "",
  },
  {
    class: "text-end",
    title: "Type",
    widht: "",
  },
  {
    class: "text-end",
    title: "Bet placed",
    widht: "",
  },
  {
    class: "text-end",
    title: "Odds req.",
    widht: "",
  },
  {
    class: "text-end",
    title: "Stake",
    widht: "",
  },
  {
    class: "text-end",
    title: "Avg. odds matched",
    widht: "",
  },
  {
    class: "text-end",
    title: "Profit/Loss",
    widht: "",
  },
];
